import { render, staticRenderFns } from "./addHagr.vue?vue&type=template&id=cf528690"
import script from "./addHagr.vue?vue&type=script&lang=js"
export * from "./addHagr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports